import style from './wallex-category-list.module.scss'
import { InView } from 'react-intersection-observer';
import styles from '../../wallex.module.scss'
import animations from '@styles/animations.module.scss'

let category_list = {
    item_1: {
        name: "Project:",
        text: "Cryptocurrency App Development"
    },
    item_2: {
        name: "Product:",
        text: "iOS and Android app"
    },
    item_3: {
        name: "Category:",
        text: "Finance"
    },
    item_4: {
        name: "Project timeline:",
        text: "8 months"
    }
}

const WallexCategoryList = () => {
    return (
        <>
            <div className={style.wallex__list}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.wallex__list__item} ${animations.scroll__animation}`}>
                                <div className={style.wallex__category}>
                                    {category_list.item_1.name}
                                </div>
                                <div className={style.wallex__item}>
                                    {category_list.item_1.text}
                                </div>
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        if (inView) {
                            entry?.target.classList.add(styles.active);
                        }
                        return (
                            <div ref={ref} className={`${style.wallex__list__item} ${styles.scroll__animation}`}>
                                <div className={style.wallex__category}>
                                    {category_list.item_2.name}
                                </div>
                                <div className={style.wallex__item}>
                                    {category_list.item_2.text}
                                </div>
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        if (inView) {
                            entry?.target.classList.add(styles.active);
                        }
                        return (
                            <div ref={ref} className={`${style.wallex__list__item} ${styles.scroll__animation}`}>
                                <div className={style.wallex__category}>
                                    {category_list.item_3.name}
                                </div>
                                <div className={style.wallex__item}>
                                    {category_list.item_3.text}
                                </div>
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }) => {
                        if (inView) {
                            entry?.target.classList.add(styles.active);
                        }
                        return (
                            <div ref={ref} className={`${style.wallex__list__item} ${styles.scroll__animation}`}>
                                <div className={style.wallex__category}>
                                    {category_list.item_4.name}
                                </div>
                                <div className={style.wallex__item}>
                                    {category_list.item_4.text}
                                </div>
                            </div>
                        )
                    }}
                </InView>
            </div>
        </>
    )


}

export default WallexCategoryList;
